import { render, staticRenderFns } from "./ConfirmDialogDelete.vue?vue&type=template&id=5454aa14"
import script from "./ConfirmDialogDelete.vue?vue&type=script&lang=js"
export * from "./ConfirmDialogDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports